module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_DE-4ded7c25b9c66a6ffd4b505f21d4e5ca.svg";